import { ITitleAccordionLeaf, IItem } from './types';
import { mapTitleAccordionLeaf } from './mapTitleAccordionLeaf';
import { RichText } from 'prismic-reactjs';
import AccordionItem from '@monofront/design-system/components/Accordion';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';

const TitleAccordionLeaf: React.FC<ITitleAccordionLeaf> = ({
  items,
  title,
}) => {
  return (
    <section className="root">
      <RichText render={title} />
      {items.map((item: IItem, index: number) => {
        return (
          <AccordionItem key={index} title={item.title} preventScroll>
            <div className="items-container">
              <RichText
                render={item.text}
                serializeHyperlink={CustomPrismicLink}
              />
            </div>
          </AccordionItem>
        );
      })}
      <style jsx>{`
        .root :global(h1) {
          margin-bottom: var(--space-4);
        }

        .root :global(.items-container) {
          padding: var(--space-5);
        }

        .root :global(h3 > strong) {
          display: block;
          font-size: var(--text-size-h2);
          font-weight: var(--font-weight-bold);
          line-height: 32.4px;
          text-align: center;
          width: auto;
        }

        .root :global(p):not(:last-child) {
          padding-bottom: var(--space-3);
        }

        .root :global(a) {
          transition: all 0.3s ease;
          color: var(--clr-link);
          text-decoration: underline;
        }

        .root :global(a:hover) {
          opacity: var(--opacity-link-hover);
        }

        .root :global(img) {
          max-width: 300px;
        }

        @media (max-width: 800px) {
          .root :global(img) {
            max-width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(TitleAccordionLeaf, mapTitleAccordionLeaf);
